import { Text, Textarea, Box } from '@nimbus-ds/components';
import InvoiceOperationEnum from '@tiendanube/common/src/enums/InvoiceOperation';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface InvoiceOperationReasonProps {
  readonly reason?: string;
  readonly onChange: (reason: string) => void;
  readonly operation: InvoiceOperationEnum;
  readonly minReasonLength: number;
  readonly maxReasonLength: number;
}

function InvoiceOperationReason({
  reason,
  onChange,
  operation,
  minReasonLength,
  maxReasonLength,
}: InvoiceOperationReasonProps): JSX.Element {
  const t = useTranslationOrders();

  return (
    <Box marginBottom="4">
      <Box marginBottom="2">
        <Text fontSize="caption" lineHeight="caption">
          {t(`invoiceModal.${operation.toLowerCase()}.reason`)}
        </Text>
      </Box>

      <Textarea
        minLength={minReasonLength}
        maxLength={maxReasonLength}
        id={`invoiceModal-${operation}`}
        name="reason"
        placeholder=""
        onChange={(e) => onChange(e.currentTarget.value)}
        value={reason}
        autoFocus
        lines={4}
      />
      <Text fontSize="base" color="neutral-textDisabled">
        {reason?.length ?? 0}/
        {t('invoiceModal.operationReasonCount', { max: maxReasonLength })}
      </Text>
    </Box>
  );
}

export default InvoiceOperationReason;
